import React from 'react';
import { useDispatch } from 'react-redux';
import Content from './Panel/Content';
import Header from './Panel/Header';
import { autoLogin } from '../store/login';

function Panel() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(autoLogin());
    console.log('ver');
  }, [dispatch]);

  return (
    <div className="container">
      <Header />
      <Content />
    </div>
  );
}

export default Panel;
